<!-- Circle.vue -->
<template>
  <div>
    <div :style="{ backgroundColor: color, width: size, height: size, borderRadius: '50%',border: color === '#FFFFFF' ? '1px solid #000000' : 'none'}"></div>
    <p>{{ color }}</p>
  </div>
</template>

<script>
export default {
  name: 'StyleCircle',
  props: {
    color: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: '176px'
    }
  }
}
</script>

<style scoped>
p {
  text-transform: uppercase;
  margin-top: 0.5em;
}
</style>
